import { type ReactNode } from 'react';
import { classes } from 'src/modules/shared/utils/styles.util';

interface MetaRowProps {
  left: ReactNode;
  right?: ReactNode;
  className?: string;
}

export const MetaRow: React.FC<MetaRowProps> = ({ left, right, className }) => {
  return (
    <div
      className={classes(
        'flex items-center justify-between gap-3 text-sm text-primary-900',
        className
      )}
    >
      <div className="flex min-w-0 items-center gap-2">{left}</div>
      {right ? (
        <div className="flex shrink-0 items-center gap-1 text-xs text-secondary-500">
          {right}
        </div>
      ) : null}
    </div>
  );
};
